var ls = require('local-storage');
let configurations = require('../configurations');
let cloudinarySettings = configurations.cloudinary_settings
let cloud_name = configurations.cloudinary_cloudName
let upload_preset = configurations.cloudinary_preset


export default {
  //
  data() {
    return {
      uploadedImgUrl: ''
    }
  },
  //
  created() {
    // two set interval cz -> a page can have 2 search.
    // 1
    setInterval(() => {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast !=
        window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage &&
        window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast =
          window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage
        })

        console.log("[CALLING SEARCH.........]")

      } else {
      }
    }, 500)
    //
    // 2
    setInterval(() => {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 !=
        window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage &&
        window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 =
          window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage
        })

        console.log("[CALLING SEARCH.........]")

      } else {
      }
    }, 500)
    //
    let str = ls.get('thumbnailImgUrl')
    let id = str.split('/')[str.split('/').length - 1]
    this.uploadedImgUrl = `https://res.cloudinary.com/${cloud_name}/image/upload/w_600,h_400,c_fill,${cloudinarySettings}/${upload_preset}/${id}`
    console.log("[uploadedImgUrl] => ", this.uploadedImgUrl)
    //
  }
}



// WEBPACK FOOTER //
// ./src/mixin/uploadImage.js